export const adapta_notificacion = ({celular, mensaje}) =>{

    let obj = {
        mensaje: mensaje,
        celular: '57' + celular,
    }

    return obj
}